import logoAbralav from '../../assets/abralav-qdd.svg'
import * as S from './style'

export default function Logo() {
    return (
        <>
            <S.LogoAbralav src={logoAbralav} />
        </>
    )
}